import { Edit, PlayStroke, TrashClearKit } from 'education-icons';
import React, { useCallback, useRef, useState } from 'react';

import { DeletionConfirmationModal } from '../__deletion-confirmation-modal/quiz-game-card__deletion-confirmation-modal';
import { SimpleCallback } from '../../../typings';
import { POPUP_DIRECTIONS, UI_KIT_TEXT_TYPOGRAPHY } from '../../constants';
import Menu from '../../menu/menu';
import Popup from '../../popup/popup';
import Text from '../../text/text';
import ThreeDots from '../../three-dots/three-dots';

interface Props {
    onQuizDeleteClick: SimpleCallback;
    onQuizEditClick: SimpleCallback;
    onStartGame: SimpleCallback;
}

const { paragraphLRegular } = UI_KIT_TEXT_TYPOGRAPHY;

const QuizGameCardMenu = (props: Props) => {
    const { onQuizDeleteClick, onQuizEditClick, onStartGame } = props;

    const popupRef = useRef<Popup | null>(null);
    const setPopupRef = (ref: Popup | null) => (popupRef.current = ref);

    const [deletionConfirmationModalOpened, setDeletionConfirmationModalOpened] = useState(false);

    const handleDeletionConfirmationModalClose = useCallback(() => {
        setDeletionConfirmationModalOpened(false);
    }, [setDeletionConfirmationModalOpened]);

    const handleQuizDeleteClick = useCallback(() => {
        popupRef.current?.hide();
        setDeletionConfirmationModalOpened(true);
    }, [setDeletionConfirmationModalOpened]);

    const handleQuizDeletionAccept = useCallback(() => {
        onQuizDeleteClick();
    }, [onQuizDeleteClick]);

    return (
        <ThreeDots
            direction={POPUP_DIRECTIONS.LEFT}
            mix="quiz-game-card__menu"
            popupProps={{
                mix: 'quiz-game-card__menu-popup',
                ref: setPopupRef,
            }}
            view={ThreeDots.VIEWS.CLEAR}
        >
            <Menu theme={Menu.THEME.ROUNDED}>
                <Menu.Item
                    onClick={(event) => {
                        event.stopPropagation();
                        onStartGame();
                    }}
                >
                    <PlayStroke className="quiz-game-card__menu-icon" />
                    <Text id="quizGameCard.menu.startGame" typography={paragraphLRegular} />
                </Menu.Item>
                <Menu.Item
                    onClick={(event) => {
                        event.stopPropagation();
                        onQuizEditClick();
                    }}
                >
                    <Edit className="quiz-game-card__menu-icon" />
                    <Text id="quizGameCard.menu.editGame" typography={paragraphLRegular} />
                </Menu.Item>
                <Menu.Divider />
                <Menu.Item
                    onClick={(event) => {
                        event.stopPropagation();
                        handleQuizDeleteClick();
                    }}
                >
                    <TrashClearKit className="quiz-game-card__menu-icon" />
                    <Text id="quizGameCard.menu.deleteGame" typography={paragraphLRegular} />
                </Menu.Item>
                <DeletionConfirmationModal
                    onAccept={handleQuizDeletionAccept}
                    onClose={handleDeletionConfirmationModalClose}
                    opened={deletionConfirmationModalOpened}
                />
            </Menu>
        </ThreeDots>
    );
};

export default QuizGameCardMenu;
